<template>
  <v-menu
    v-model="sheet"
    :close-on-content-click="false"
    :nudge-width="300"
    max-width="300"
    :position-x="x"
    :position-y="y"
  >
    <v-card class="px-6 pt-3 py-0">
      <div class="d-flex justify-space-between">
        <p class="text-center text-h6">Chart Settings</p>
      </div>
      <v-divider class="mt-0" />
      <div>
        <v-row class="ma-0">
          <v-col cols="12" v-if="!under_development">
            <v-row>
              <div class="subtitle-1">Values</div>
            </v-row>
            <v-row>
              <v-checkbox
                v-for="value in config.chart_values"
                :key="value.id"
                v-model="show_values[value.id]"
                :label="`${value.label}`"
                @change="updateValue(value.id, value.name)"
                :disabled="is_loading"
                :color="value.color"
                class="pa-0 ma-0"
              >
                <template v-slot:label>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ value.label }}</span>
                    </template>
                    <span>{{ value.tooltip }}</span>
                  </v-tooltip>
                </template>
              </v-checkbox>
            </v-row>
          </v-col>
          <v-col cols="12"
            ><v-row>
              <div class="subtitle-1 pr-1">Data Point Size</div>
              <TooltipVT :text="tooltip_text" />
            </v-row>
            <v-row class="mr-12">
              <v-slider
                v-model="data_point_size"
                color="cautionText"
                step="4"
                min="0"
                max="8"
                thumb-label
                @change="updateDataPoints"
              ></v-slider>
            </v-row>
          </v-col>

          <v-col cols="12"
            ><v-row>
              <div class="subtitle-1 pr-1">Color Palette</div>
            </v-row>
            <v-row>
              <v-radio-group row mandatory class="pa-0 ma-0" @change="updateColorPalette">
                <v-radio
                  v-for="value in filtered_palettes"
                  :key="value.id"
                  :label="value.label"
                  :value="value.id"
                  :color="value.radio_color"
                />
              </v-radio-group>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import TooltipVT from "../components/TooltipVT";
import { content } from "../../config/general.js";

export default {
  name: "ChartOptions",
  components: {
    TooltipVT,
  },
  props: {
    settings_menu_props: Object,
    config: {
      type: Object,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    is_loading: Boolean,
    under_development: Boolean,
  },
  data() {
    return {
      platform: "VT",
      general_config: content,
      sheet: false,
      show_values: [true, false, false], // Mean, Min, Max
      data_point_size: 0,
      x: null,
      y: null,
      tooltip_text:
        "Data Point might not be visible if the dataset is too large, you can zoom in to see the data points.",
    };
  },
  created() {
    if (process.env.VUE_APP_TITLE) this.platform = process.env.VUE_APP_TITLE;
  },
  watch: {
    settings_menu_props: function (val) {
      this.sheet = val.state;
      this.x = val.x;
      this.y = val.y + 15;
    },
  },
  methods: {
    closeSettingsMenu() {
      this.$emit("closeSettingsMenu");
    },
    updateDataPoints() {
      this.$emit("updateDataPoints", this.data_point_size);
    },
    updateValue(id, name) {
      this.$emit("updateVisibleLines", { type: name, show: this.show_values[id] });
    },
    updateColorPalette(id) {
      this.$emit("updateColorPalette", id);
    },
  },
  computed: {
    filtered_palettes() {
      // loop general_config.chart_palettes object and return only the ones that are available for the current platform or no platform specified
      return Object.values(this.general_config.chart_palettes).filter(
        (palette) => palette.platform === this.platform || !palette.platform
      );
    },
  },
};
</script>
